import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-118" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-119" data-mp="1dx07kidxnd91">
        <SectionHeading id="modules-title" data-id="element-120" data-mp="1dybakfzk0gz3">I {totalVolumes} <span className="text-orange-400" data-id="element-121" data-mp="2bkihhwjbylem">Volumi Completi</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-122" data-mp="26lfba8rm6952">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-slate-800 bg-slate-900 p-6 shadow-lg shadow-black/30" data-id="element-123" data-mp="21k84od17jfzz" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-124" data-mp="1nttjvcg61ciw">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-slate-700 bg-slate-950 text-orange-400" data-id="element-125" data-mp="18xknqjrknfap">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-126" data-mp="1dy8k7kykkocb" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-127" data-mp="103fzm83tohyv">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-white" data-id="element-128" data-mp="q6tfjljbluxw">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-300" data-id="element-129" data-mp="v4uy85cu3s8u">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}